import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconTask from '@/icons/Task.svg';

import { useFilters } from '../FiltersState';
import { useTaskOptions } from '../utils';

export const FiltersTask = () => {
  const { t, i18n } = useLingui();

  const {
    tasks: { tasks, setTasks },
  } = useFilters();

  const taskOptions = useTaskOptions();

  const toggleTask = (task: (typeof tasks)[number]) => {
    if (tasks.includes(task)) {
      setTasks(tasks.filter((t) => t !== task));
    } else {
      setTasks([...tasks, task]);
    }
  };

  const options =
    taskOptions.length > 0 ? (
      taskOptions.map(({ id, label }) => (
        <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
      ))
    ) : (
      <FilterItemNoResults />
    );

  return (
    <FiltersSubMenu
      id="task"
      icon={<IconTask />}
      label={t({ id: 'requests.filters.task.label', message: 'Task' })}
      count={tasks.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'requests.filters.task.label', message: 'Task' })}
        values={tasks}
        onChange={toggleTask}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
